import { LoggerStorageKey } from '../../../enums/loggerStorageKey';
import { Logger } from '../../../helpers/logger';
import { Env } from '../../../helpers/env';

export const logger = new Logger(LoggerStorageKey.SHOW_LOGGER, Env.isDevelop());
